import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import { DialogResult, Dialogs, DialogService } from 'dspx-core';

import { DeactivationGuard } from '../interfaces/deactivation-guard.interface';

// See https://stackoverflow.com/a/41187919
@Injectable({
  providedIn: 'root'
})
export class ComponentDeactivationService implements CanDeactivate<DeactivationGuard> {

  constructor(
    private dialogService: DialogService) {
  }

  // If there are no pending changes, just allow deactivation; else confirm first
  canDeactivate = (component: DeactivationGuard) =>
    component.canDeactivate()
      ? true
      : this.openConfirmDialog();

  // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
  // when navigating away from your angular app, the browser will show a generic warning message (see http://stackoverflow.com/a/42207299/7307355)
  private openConfirmDialog = () => this.dialogService
    .showConfirmPopup(Dialogs.UNSAVED_CHANGES)
    .pipe(map(data => data === DialogResult.ACCEPTED));
}
